import { createSlice } from "@reduxjs/toolkit";
import { getAllPartners } from "../actions/partners.actions";

const initialState = {
  partners: [] as any,
  loading: false,
  error: null as unknown | null,
};
export const partnersSlice = createSlice({
  name: "partners",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllPartners.pending, (state) => {
      state.loading = true;
    })
    .addCase(getAllPartners.fulfilled, (state, action) => {
      state.partners = action.payload;
      state.loading = false;
    })
    .addCase(getAllPartners.rejected, (state, action) => {
      state.partners = [];
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default partnersSlice.reducer;
